import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d42df3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"row","flex-wrap":"wrap"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "space-between",
  style: {"margin-bottom":"8px"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  style: {"color":"#909399"}
}
const _hoisted_8 = { class: "space-between" }
const _hoisted_9 = {
  class: "row",
  style: {"min-width":"80px"}
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"#909399"}
}
const _hoisted_13 = { class: "space-between" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  style: {"color":"#909399"}
}
const _hoisted_16 = { style: {"height":"66px","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_17 = { style: {"color":"red"} }
const _hoisted_18 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_19 = {
  key: 1,
  style: {"color":"#909399"}
}

import { ComponentPublicInstance, computed, reactive, ref, shallowRef, watch } from 'vue';
import WidgetTablePagination from '@/components/business/crud/table/WidgetTablePagination.vue';
import WidgetTableButton from '@/components/business/crud/table/WidgetTableButton.vue';
import WidgetSearch from '@/components/business/crud/form/WidgetSearch.vue';
import { createSearchService } from '@/components/business/crud/service/CrudSearchService';
import _ from 'lodash';
import { createCrudTableService } from '@/components/business/crud/service/CrudTableService';
import { useQueryParam } from '@/util/queryParam';
import ScPage from '@/components/common/page/ScPage.vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import StatusIcon from '@/components/business/crud/common/StatusIcon.vue';
import { windows } from '@/components/common/window/Windows';
import { request } from '@/util/request';
import { proxyTip } from '@/views/management/common/util';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';
import { app } from '@/models/App';
import { useActiveElement, useMagicKeys, whenever } from '@vueuse/core';
import EditText from '@/components/business/crud/common/EditText.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceIndex',
  setup(__props) {

const deviceStatusValue: Record<string, boolean> = {
  online: true,
  error: false,
};

function deviceStatusTip(item: any) {
  if (item.status === 'online') {
    return '设备在线';
  } else if (item.status === 'offline') {
    return '设备离线';
  } else {
    return '设备异常\n' + item.exception;
  }
}

const proxyStatusValue: Record<string, boolean> = {
  normal: true,
  error: false,
};



const searchService = createSearchService('management', 'device');
const { form, groups, getCondition } = searchService.use();
const tableService = createCrudTableService('management', 'device');
const { schema, columns, listData, rowSelection, onChange, buttons } =
  tableService.use();

const extraButtons = computed(() => {
  return [
    buttons.value[0],
    {
      type: 'table',
      text: isSelectedAll.value ? '全消' : '全选',
      tip: '快捷键Ctrl + A',
      icon: isSelectedAll.value ? 'CloseOutlined' : 'CheckOutlined',
      enable: true,
      handler: () => toggleSelectAll(),
    },
    ...buttons.value.slice(1),
  ];
});

const activeElement = useActiveElement();
const notUsingInput = computed(
  () =>
    activeElement.value?.tagName !== 'INPUT' &&
    activeElement.value?.tagName !== 'TEXTAREA'
);
const keys = useMagicKeys({
  passive: false,
  onEventFired(e) {
    if (e.ctrlKey && e.key === 'a' && notUsingInput.value) e.preventDefault();
  },
});

whenever(keys.ctrl_a, () => {
  if (notUsingInput.value) {
    toggleSelectAll();
  }
});
const isSelectedAll = computed(
  () =>
    rowSelection.value?.selectedRowKeys.value.length === listData.list.length
);

function toggleSelectAll() {
  if (isSelectedAll.value) {
    rowSelection.value?.onChange([], []);
  } else {
    rowSelection.value?.onChange([], listData.list);
  }
}

tableService.listConfig.addLoad = ['proxies', 'exception'];
// 处理选中
const selectedKeyMap = computed(() => {
  const value: Record<string, any> = {};
  rowSelection.value?.selectedRowKeys.value.map((i) => (value[i] = i));
  return value;
});

function toggleSelect(row: any) {
  const selectedRows: any[] = [];
  listData.list.map((i) => {
    if (selectedKeyMap.value[i.id] && i.id !== row.id) {
      selectedRows.push(i);
    }
  });
  if (!selectedKeyMap.value[row.id]) {
    selectedRows.push(row);
  }
  rowSelection.value?.onChange([], selectedRows);
}

const searchData = useQueryParam('searchData');
const readonlyFields = useQueryParam('readonlyFields');

/**
 * 查询时候修改列表查询条件，将查询数据同步到url上
 */
function onSearch() {
  tableService.listConfig.condition = getCondition();
  searchData.value = _.cloneDeep(form.data.value);
}

let isInit = false;

const queryParam = useQueryParam('table');
searchService.init().then(() => {
  /**
   * 监听url数据，来修改查询表单数据
   */
  watch(
    searchData,
    () => {
      const queryValue = searchData.value || {};
      if (!_.isEqual(queryValue, form.data.value)) {
        form.data.value = queryValue;
      }
    },
    { deep: true, immediate: true }
  );
  /**
   * 监听url数据，来设置查询表单只读字段
   * todo 双向绑定
   */
  watch(
    () => readonlyFields,
    () => {
      if (readonlyFields.value) {
        searchService.setReadonlyFields(readonlyFields.value);
        if (isInit) {
          onSearch();
        }
      }
    },
    { deep: true, immediate: true }
  );
  /**
   * 监听url数据，来修改列表排序字段
   * todo 双向绑定
   */
  watch(
    () => queryParam.value?.orderBy,
    () => {
      onChange(undefined, undefined, queryParam.value?.orderBy || []);
    },
    { deep: true, immediate: true }
  );
  if (!isInit) {
    isInit = true;
    onSearch();
  }
  tableService.init();
});
const orderType = ref(0)
const orders = reactive([[{ column: 'createTime', order: 'desc' }], [{ column: 'createTime', order: 'asc' }]])
watch(orderType, () => {
  tableService.listConfig.orderBy = orders[orderType.value]
})
const table = ref<ComponentPublicInstance>();

function backTopTarget() {
  return table.value?.$el;
}

const rowButtons = {
  edit: async (row: any) => {
    const id = windows.open({
      content: {
        type: 'route',
        href: `/management/device/update?id=${row.id}`,
      },
      title: '编辑设备',
    });
    windows.getCloseData(id).then(async (res) => {
      if (res) {
        await tableService.refreshList();
      }
    });
  },
  nameEdit: async function (device: any, name: string) {
    const res = await request('/management/device/update', {
      id: device.id,
      data: { name },
    });
    if (res) {
      device.name = name;
      return true;
    }
  },
  proxyEdit: async function (row: any) {
    const id = windows.open({
      content: {
        type: 'component',
        component: shallowRef(HasMany),
        props: {
          propName: 'proxies',
          info: {
            title: '绑定线路',
            status: 'edit',
          },
          widget: app.data.widgetMap.management.device.widgets.proxies.type,
          data: row,
        },
      },
      title: row.name + '绑定线路编辑',
      width: 1280,
      height: 800,
      padding: 20,
    });
    const res = await windows.getCloseData(id);
    if (res) {
      await tableService.refreshList();
    }
  },
  async selectProxy(device: any, proxy: any) {
    request('/management/device/update', {
      id: device.id,
      data: { selectedProxy: proxy.id },
    }).then((res) => {
      if (res) {
        device.selectedProxy = proxy.id;
      }
    });
  },
  switchProxySetting(device: any, value: boolean) {
    const old = device.proxySetting;
    device.proxySetting = value;
    request('/management/device/update', {
      id: device.id,
      data: { proxySetting: value },
    }).then((res) => {
      if (!res) {
        device.proxySetting = old;
      }
    });
  },
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createBlock(ScPage, {
    title: _unref(schema).title,
    desc: _unref(schema).desc,
    ref_key: "table",
    ref: table
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WidgetSearch, {
          "is-hidden": false,
          form: _unref(form),
          groups: _unref(groups),
          onSearch: onSearch
        }, null, 8, ["form", "groups"]),
        _createVNode(WidgetTableButton, { buttons: extraButtons.value }, {
          right: _withCtx(() => [
            _createVNode(_component_a_select, {
              placeholder: "选择排序",
              value: orderType.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((orderType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间倒序")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间顺序")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["buttons"]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData).list, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["block", { selected: selectedKeyMap.value[item.id] }]),
              onClick: () => toggleSelect(item),
              key: key
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_checkbox, {
                    checked: selectedKeyMap.value[item.id],
                    style: {"margin-right":"8px"}
                  }, null, 8, ["checked"]),
                  _createVNode(_component_a_tooltip, { title: "设备分组" }, {
                    default: _withCtx(() => [
                      (item.group)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.group?.name), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, "无分组"))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", {
                  class: "row",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(_component_a_tooltip, { title: "切换代理设置" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_switch, {
                        style: {"margin-right":"8px"},
                        size: "small",
                        checked: item.proxySetting,
                        "onUpdate:checked": ($event: any) => (rowButtons.switchProxySetting(item, $event))
                      }, null, 8, ["checked", "onUpdate:checked"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(ScBtn, {
                    handler: () => rowButtons.edit(item),
                    icon: "EditFilled",
                    size: "small",
                    style: {"margin-right":"8px"}
                  }, null, 8, ["handler"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_tooltip, {
                    overlayStyle: { whiteSpace: 'pre-line' },
                    title: deviceStatusTip(item)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(StatusIcon, {
                        value: deviceStatusValue[item.status],
                        size: 14
                      }, null, 8, ["value"])
                    ]),
                    _: 2
                  }, 1032, ["title"]),
                  _createVNode(EditText, {
                    value: item.name,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    handler: (name) => rowButtons.nameEdit(item, name)
                  }, null, 8, ["value", "handler"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags.list, (tag, tKey) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tag",
                      key: tKey
                    }, _toDisplayString(tag.name), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_tooltip, { title: "加速包" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.accelerators.list, (accelerator, tKey) => {
                      return (_openBlock(), _createElementBlock("div", { key: tKey }, _toDisplayString(accelerator.name), 1))
                    }), 128)),
                    (item.accelerators.list.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 无加速包 "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_tooltip, { title: "代理规则" }, {
                  default: _withCtx(() => [
                    (item.rule)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.rule?.name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, "无代理规则"))
                  ]),
                  _: 2
                }, 1024),
                _createVNode(ScBtn, {
                  icon: "FormOutlined",
                  type: "text",
                  handler: () => rowButtons.proxyEdit(item)
                }, null, 8, ["handler"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (item.proxies.list.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.proxies.list, (proxy, pKey) => {
                      return (_openBlock(), _createBlock(_component_a_tooltip, {
                        placement: "right",
                        overlayStyle: { whiteSpace: 'pre-line' },
                        title: _unref(proxyTip)(proxy),
                        key: pKey,
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_popconfirm, {
                            "ok-text": "确定",
                            "cancel-text": "取消",
                            onConfirm: ($event: any) => (rowButtons.selectProxy(item, proxy))
                          }, {
                            title: _withCtx(() => [
                              _createTextVNode(" 确定要切换到 "),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(proxy.name), 1),
                              _createTextVNode(" 吗 ")
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass([{ selected: proxy.id === item.selectedProxy }, "space-between"]),
                                style: {"padding":"0 4px"}
                              }, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(proxy.name) + " | " + _toDisplayString(proxy.username) + " | " + _toDisplayString(proxy.typeText) + "://" + _toDisplayString(proxy.host) + ":" + _toDisplayString(proxy.port), 1),
                                _createVNode(StatusIcon, {
                                  style: {"margin-left":"8px"},
                                  value: proxyStatusValue[proxy.status]
                                }, null, 8, ["value"])
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 2
                      }, 1032, ["title"]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, "未分配代理线路"))
              ])
            ], 10, _hoisted_3))
          }), 128))
        ]),
        _createVNode(WidgetTablePagination, {
          count: _unref(listData).count,
          "page-num": _unref(tableService).listConfig.pageNum,
          "onUpdate:pageNum": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableService).listConfig.pageNum) = $event)),
          "page-size": _unref(tableService).listConfig.pageSize,
          "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableService).listConfig.pageSize) = $event))
        }, null, 8, ["count", "page-num", "page-size"]),
        _createVNode(_component_a_back_top, {
          target: backTopTarget,
          visibilityHeight: 100
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "desc"]))
}
}

})